import { Autocomplete, Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function AWSConnectForm({
  onSubmit,
  awsRegions,
  guideMode = false,
}) {
  const formInitialValues = {
    roleARN: "",
    region: "",
  };

  const formCheckoutSchema = yup.object().shape({
    roleARN: yup.string().required("required"),
    region: yup.string().required("required"),
  });

  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box mt={1} maxWidth={"700px"}>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="roleARN"
                label="Role ARN"
                value={values.roleARN}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.roleARN && !!errors.roleARN}
                helperText={touched.roleARN && errors.roleARN}
                autoComplete="off"
                disabled={guideMode}
              />
              <Autocomplete
                options={awsRegions}
                getOptionLabel={(option) => `${option.name} (${option.code})`}
                onChange={(event, value) =>
                  handleChange({
                    target: {
                      name: "region",
                      value: value?.code || "",
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="filled"
                    name="region"
                    label="Region to scan"
                    value={values.region}
                    onBlur={handleBlur}
                    error={!!touched.region && !!errors.region}
                    disabled={guideMode}
                    helperText={touched.region && errors.region}
                  />
                )}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
